import {compose} from "redux";
import {connect} from "react-redux";
import {setBrandInstance} from "../../actions/brand";
import BrandInstancePage from "../../components/gridPages/BrandInstancePage";
import type {ApplicationState} from "../../reducers";

function mapStateToProps(state: ApplicationState, ownProps) {
    const brandInstances = state.config.brandInstances;
    const autoselectedInstance = brandInstances !== null
        ? brandInstances.length === 1
            ? brandInstances[0]
            : ownProps.match.params.manufacturerName
                ? brandInstances.find(instance => instance.manufacturerName === ownProps.match.params.manufacturerName)
                : brandInstances.find(instance => instance.manufacturerName === state.config.defaultBrand) || null
        : null;
    const autoselectSource = brandInstances !== null && brandInstances.length > 1 && ownProps.match.params.manufacturerName
        ? "url_path"
        : "data_param";

    return {
        autoselectedInstance: autoselectedInstance,
        autoselectSource: autoselectSource,
        brandInstances: state.config.brandInstances,
        overrideHeadline: state.config.brandSelectOverrideHeadline,
        shouldRender: (state.config.garageId || state.config.garageGroupId) && !autoselectedInstance,
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        disableConfig: () => {
        },
        selectBrand: (brand, selectionSource = "brand_select_screen") => {
            dispatch(setBrandInstance(brand, selectionSource));
            const {history} = ownProps;
            if (!ownProps.location.pathname.includes(`/brand/${brand.manufacturerName}`)) {
                history.push(`/brand/${brand.manufacturerName}/shop`);
            }
        }
    };
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(BrandInstancePage);
